module.exports = __FOREMAN_VENDOR__REACT_DND_HTML_5_BACKEND__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_DND_HTML_5_BACKEND__"
// module id = react-dnd-html5-backend
// module chunks = 0